var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manuel-ban-modal wrapper" },
    [
      _vm.internalBanModalVisible
        ? _c(
            "Modal2",
            {
              staticClass: "ban-modal",
              attrs: { title: _vm.$t("message.banModalTitle") },
              on: {
                cancel: _vm.closeModal,
                ok: function ($event) {
                  return _vm.suppressionProcess(_vm.type, _vm.value)
                },
              },
            },
            [
              _c("table", { staticClass: "ban-table" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.platform")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("chatbotv2.value")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.sendingAllow")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("message.receiving")))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", { staticClass: "manual-ban-row" }, [
                  _c(
                    "td",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          staticClass: "manual-ban-select",
                          attrs: { id: "type" },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        },
                        _vm._l(_vm.types, function (t) {
                          return _c("a-select-option", { key: t }, [
                            _vm._v(_vm._s(t) + "\n                        "),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value,
                          expression: "value",
                        },
                      ],
                      staticClass: "value-input",
                      attrs: { type: "text" },
                      domProps: { value: _vm.value },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.value = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("a-switch", {
                        staticClass: "ml-2 mr-2",
                        attrs: {
                          "un-checked-children": "✔",
                          "checked-children": "✖",
                        },
                        on: {
                          change: function ($event) {
                            this.inbound = !this.inbound
                          },
                        },
                        model: {
                          value: _vm.inbound,
                          callback: function ($$v) {
                            _vm.inbound = $$v
                          },
                          expression: "inbound",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("a-switch", {
                        staticClass: "ml-2 mr-2",
                        attrs: {
                          "un-checked-children": "✔",
                          "checked-children": "✖",
                        },
                        on: {
                          change: function ($event) {
                            this.outbound = !this.outbound
                          },
                        },
                        model: {
                          value: _vm.outbound,
                          callback: function ($$v) {
                            _vm.outbound = $$v
                          },
                          expression: "outbound",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }